export default __webpack_public_path__ + "static/speakerRecog-f8389dfb3a1c40748ffa0201941b8ae4.jpg";